import computed from './computed'
import data from './data'
import validations from './validations'

export default {
  computed,
  validations,
  data
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/resources/index.js